import { EventPermissions } from "@clockwise/schema";
import { EventCardAttendee } from "../types";

export const getListOfNonRemovableAttendeeIds = (
  fetchedEventPermissions: EventPermissions,
  originalAttendees: EventCardAttendee[],
) => {
  const userCanOnlyInvite = fetchedEventPermissions === EventPermissions.INVITE;
  const attendeeIdsThatCanNotBeEdited = new Set<string>();
  for (const attendee of originalAttendees) {
    if (attendee.isOrganizer || userCanOnlyInvite) {
      attendeeIdsThatCanNotBeEdited.add(attendee.primaryCalendar);
    }
  }
  return attendeeIdsThatCanNotBeEdited;
};
